import { render, staticRenderFns } from "./leads.vue?vue&type=template&id=f2ed1152&scoped=true&"
import script from "./leads.vue?vue&type=script&lang=js&"
export * from "./leads.vue?vue&type=script&lang=js&"
import style0 from "./leads.vue?vue&type=style&index=0&id=f2ed1152&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ed1152",
  null
  
)

export default component.exports